


import service from '../utils/request'; 

export const getFullImageUrl = (coverPath) => {
    if (!coverPath) return "/default-banner.jpg"; // 默认图片
    if (coverPath.startsWith("http")) return coverPath; // 已经是完整URL
    // 处理相对路径并解码URL编码
  return `${import.meta.env.VITE_API_URL}${decodeURIComponent(coverPath)}`;
};

/**
 * 查询fea-additional插件设置
 * @returns {Promise<Object>} 包含插件设置的Promise
 */
export const fetchFeaAdditionalSettings = async () => {
  try {
    const response = await service.get(
      '/apis/api.feaAdditionalPlugin.halo.run/v1alpha1/getPluginSettings'
    );
    return response; // 返回插件设置数据
  } catch (error) {
   
    throw error;
  }
};



/**
 * 搜索接口调用
 * @param {string} keyword 关键词
 * @param {number} [limit=10] 返回条数限制，默认10
 * @returns {Promise<Object>} 搜索结果
 */
export const searchContent = async (keyword, limit = 10) => {
  try {
    const response = await service.post(
      '/apis/api.halo.run/v1alpha1/indices/-/search',
      {
        keyword,
        limit,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};



// 注册账号
// 注册用户接口
export function registerUser(data) {
  return service.post('/apis/api.feaVip.halo.run/v1alpha1/myRegister', data);
}


// 登录接口
export function login(username, password,captcha,captchaKey) {
  return service.post('/apis/api.feaVip.halo.run/v1alpha1/myLogin', {
    username,
    password,
     captcha,
    captchaKey
  });
}

// 获取当前登录用户信息
export function getCurrentUser() {
  return service.get('/apis/api.feaVip.halo.run/v1alpha1/whoami')
}

// 验证码
export function getCaptcha () {
  return service.get('/apis/api.feaVip.halo.run/v1alpha1/captcha')
}


// 插件设置
export function getConfigSetting () {
  return service.get('/apis/api.feaAdditionalPlugin.halo.run/v1alpha1/getPluginSettings')
}



//查询招聘信息列表
export function getRecruitmentinfosList(page, size, type) {
  return service.get(
    `/apis/api.feaAdditionalPlugin.halo.run/v1alpha1/recruitmentinfos?page=${page}&size=${size}&labelSelector=type=${type}`
  );
}


// 插件设置-timeline
export function getConfigSettingTimeLine () {
  return service.get('/apis/api.feaAdditionalPlugin.halo.run/v1alpha1/getPluginSettingsTimeLine')
}
